import { notification } from "antd";
import Axios from "axios";
import { ICleanMessage } from "../config/types";

export const URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5585"
    : "https://crm.realtycalendar.ru");

export const axios = Axios.create({
  baseURL: `${URL}/api/cleaners`,
});

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("cleaner_id");

      window.location.reload();
    } else if (status === 500) {
      if (error?.response?.data?.data) {
        notification.error({
          message: "Ошибка",
          description: error.response.data.data,
        });
      }

      return Promise.reject(error);
    } else {
      notification.error({
        message: "Ошибка сети",
        description: "Не удалось отправить запрос на сервер",
      });

      return Promise.reject(error);
    }
  },
);

export const API = {
  subscriptions: {
    async saveSubscription(dto: PushSubscription) {
      try {
        const { data } = await axios.post<any>("push_subscriptions", dto);
        return data;
      } catch (error) {
        console.log(" error:", error);
      }
    },
  },
  meters: {
    async uploadPhoto(formData: any, setProgress?: Function) {
      try {
        const { data } = await axios.post("meters/photos", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const { progress } = progressEvent;

            progress && setProgress && setProgress((progress * 100).toFixed(0));
          },
        });

        return data;
      } catch (error) {
        console.log(" error:", error);
      }
    },
    async saveReadings({
      clean_id,
      ...values
    }: {
      clean_id: number;
      cold_water: number;
      hot_water: number;
      electricity: number;
      electricity_day: number;
      electricity_night: number;
      gas: number;
      photos: string[];
    }) {
      try {
        const result = await axios.post<any>(`meters/${clean_id}`, values);

        if (result.status === 200) {
          notification.success({
            message: "Показания отправлены",
          });
        }

        return result.data;
      } catch (error) {
        console.log(" error:", error);
      }
    },
  },
  async login(dto: {
    agency_id?: string;
    password: string;
    telegram?: number;
    telegram_username?: string;
  }) {
    try {
      const { data } = await axios.post("login", dto);

      return data;
    } catch (error) {
      console.error(" error:", error);
      throw error;
    }
  },
  async logout() {
    try {
      const { data } = await axios.post("logout");

      return data;
    } catch (error) {
      console.error(" error:", error);
    }
  },
  async getCleans() {
    try {
      const { data } = await axios.get<any>("cleans");
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getCleanMessages(filters: { clean_id?: string | number }, page = 1) {
    try {
      const { clean_id, ...params } = filters;

      if (!clean_id) {
        return { messages: [], total: 0 };
      }

      const { data } = await axios.get<{ messages: ICleanMessage[], total: number }>(`cleans/${clean_id}/messages`, {
        params: {
          ...params,
          page
        }
      });
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getSettings() {
    try {
      const { data } = await axios.get<any>("settings");
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getDoneCleans() {
    try {
      const { data } = await axios.get<any>("cleans/done");
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getTheory() {
    try {
      const { data } = await axios.get<any>("theory");
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getHowin(object_id: any) {
    try {
      const { data } = await axios.get<any>("howin/" + object_id);
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async getInstruction(object_id: any) {
    try {
      const { data } = await axios.get<any>("instruction/" + object_id);
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async changeStatusOfClean(dto: any) {
    const response = await axios.patch<any>("cleans", dto);
    return response;
  },
  // async changeStatusOfClean(dto: any) {
  //   try {
  //     const { data } = await axios.patch<any>("cleans", dto);
  //     return data;
  //   } catch (error) {
  //     console.log(" error:", error);
  //   }
  // },
  async changeKey(dto: any, setProgress?: Function) {
    try {
      const { file, curkey, object_id, rent_id, clean_id } = dto;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("curkey", curkey);
      formData.append("object_id", object_id);
      formData.append("rent_id", rent_id);
      formData.append("clean_id", clean_id);
      const { data } = await axios.patch<any>("cleans/object/key", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const { progress } = progressEvent;

          progress && setProgress && setProgress((progress * 100).toFixed(0));
        },
      });
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async addTask(dto: any) {
    try {
      const { data } = await axios.post<any>("cleans/tasks/buy", dto);
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async addFix(dto: any, setProgress?: Function) {
    try {
      const { files, text, clean_id, rent_id, object_id } = dto;
      const formData = new FormData();
      // formData.append("files", files);
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append("files", files[i]);
        }
      }
      formData.append("text", text);
      formData.append("clean_id", clean_id);
      formData.append("object_id", object_id);
      if (rent_id) {
        formData.append("rent_id", rent_id);
      }
      const { data } = await axios.post<any>("cleans/tasks/fix", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const { progress } = progressEvent;

          progress && setProgress && setProgress((progress * 100).toFixed(0));
        },
      });
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async finishClean(dto: any) {
    try {
      const { data } = await axios.post<any>("cleans/finish", dto);
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async uploadFinishClean(dto: any, setProgress?: Function) {
    try {
      const { files, clean_id } = dto;
      const formData = new FormData();
      // formData.append("files", files);
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append("files", files[i]);
        }
      }
      formData.append("clean_id", clean_id);

      const { data } = await axios.post<any>("cleans/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const { progress } = progressEvent;

          progress && setProgress && setProgress((progress * 100).toFixed(0));
        },
      });
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
  async addComment(dto: any, setProgress?: Function) {
    try {
      const { files, text, clean_id, rent_id } = dto;
      const formData = new FormData();
      // formData.append("files", files);
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append("files", files[i]);
        }
      }
      formData.append("text", text);
      formData.append("clean_id", clean_id);
      if (rent_id) {
        formData.append("rent_id", rent_id);
      }
      const { data } = await axios.post<any>("cleans/comment", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const { progress } = progressEvent;

          progress && setProgress && setProgress((progress * 100).toFixed(0));
        },
      });
      return data;
    } catch (error) {
      console.log(" error:", error);
    }
  },
};
